require.register("app/restaurant/show/SepaTab", function(exports, require, module){
  $0
  
});

